<template>
    <div :id="ID_BASE + idContenedor" class="container-fluid contenedor-tarjetas-principal">
      <h1 v-if="opciones.conTitulo.mostrar" class="titulo" :style="opciones.conTitulo.estilosCss">{{ opciones.conTitulo.texto }}</h1>
      <div v-if="mostrarTarjetas" id="contenedor-tarjetas" :class="(opciones.centrarTarjetas) ? 'row d-flex justify-content-center' : 'row'">
          <div v-for="(tarjeta,index) in tarjetas" :key="'crd' + index" class="col-xs-3 col-sm-3 col-md-3 col-lg-3 pt-4 pr-2">
              <div :class="[(esMenuDeUsuario({ nombreMenu: tarjeta.Titulo })) ? 'tarjeta-enlaces' : 'tarjeta-enlaces deshabilitar-tarjeta']">
                  <!-- CAMPOS DESCRIPTIVOS -->
                  <div class="campos-descriptivos-area">
                      <i :class="tarjeta.Icono"></i>
                      <h3 class="titulo-area" @click="irADocumentosDeArea(tarjeta)">{{ tarjeta.Titulo }}</h3>
                      <h4>{{ tarjeta.SubTitulo }}</h4>
                  </div>
                  <!-- SECCION DE ENLACES -->
                  <div :id="'contenedor-enlaces-' + tarjeta.identificador">
                      <div v-for="(enlace,index) in tarjeta.enlaces" :key="'crd' + index">
                          <div v-show="(index + 1) <= 4" class="form-inline">
                              <a v-if="campoRequeridoEsValido(enlace.RutaParaAccesar)&& enlace.RutaParaAccesar.includes('http')" @click="ocultarTooltip" class="enlace" target="_blank" :href="enlace.RutaParaAccesar" v-tooltip:right="enlace.Titulo">
                                <i id="icono-enlaces" @click="ocultarTooltip" class="fas fa-arrow-circle-right"></i>{{ limitarLongitudDeEnlace(enlace.Titulo) }}
                              </a>
                              <router-link v-else-if="campoRequeridoEsValido(enlace.RutaParaAccesar)" @click.native="ocultarTooltip" class="enlace" :to="enlace.RutaParaAccesar + '/' + enlace.Titulo.replace(/\s/g,'')" v-tooltip:right="enlace.Titulo">
                                <i id="icono-enlaces" @click="ocultarTooltip" class="fas fa-arrow-circle-right"></i>{{ limitarLongitudDeEnlace(enlace.Titulo) }}
                              </router-link>
                          </div>
                          <div v-if="(index + 1) == MAXIMO_ENLACES_MOSTRAR && tarjeta.enlaces.length > MAXIMO_ENLACES_MOSTRAR && !tarjeta.mostrarEnlacesOcultos" class="form-inline justify-content-center">
                            <span @click="evtMostrarElacesOcultos({ crd: tarjeta, mostrar: true })">Mostrar mas&nbsp;<i class="fas fa-caret-down"></i></span>
                          </div>
                          <div v-show="(index + 1) > 4" :class="(tarjeta.mostrarEnlacesOcultos) ? 'form-inline' :'enlaces-ocultos form-inline'">
                              <a v-if="campoRequeridoEsValido(enlace.RutaParaAccesar)&& enlace.RutaParaAccesar.includes('http')" class="enlace" @click="ocultarTooltip" target="_blank" :href="enlace.RutaParaAccesar" v-tooltip:right="enlace.Titulo">
                                <i id="icono-enlaces" @click="ocultarTooltip" class="fas fa-arrow-circle-right"></i>{{ limitarLongitudDeEnlace(enlace.Titulo) }}
                              </a>
                              <router-link v-else-if="campoRequeridoEsValido(enlace.RutaParaAccesar)"  @click.native="ocultarTooltip" class="enlace" :to="enlace.RutaParaAccesar + '/' + enlace.Titulo.replace(/\s/g,'')" v-tooltip:right="enlace.Titulo">
                                <i id="icono-enlaces"  @click="ocultarTooltip" class="fas fa-arrow-circle-right"></i>{{ limitarLongitudDeEnlace(enlace.Titulo) }}
                              </router-link>
                          </div>
                      </div>
                      <div v-if="tarjeta.enlaces.length < 1" id="contenedor-sin-enlaces" class="text-center">
                          <i class="fas fa-search-minus text-center"></i>
                          <div id="seccion-sin-enlaces">
                              <h5>Sin enlaces</h5>
                          </div>
                      </div>
                      <div v-if="tarjeta.enlaces.length > MAXIMO_ENLACES_MOSTRAR && tarjeta.mostrarEnlacesOcultos" class="form-inline justify-content-center">
                            <span @click="evtMostrarElacesOcultos({ crd: tarjeta, mostrar: false })">Ocultar&nbsp;<i class="fas fa-caret-up"></i></span>
                      </div>
                  </div>
                  <!-- ACCIONES -->
                  <div id="contenedor-acciones">
                      <button type="button" @click="irADocumentosDeArea(tarjeta)" class="btn btn-block btn-primary">Documentos</button>
                  </div>
              </div>
          </div>
      </div>
    </div>
</template>
<script>
import CHeader from "@/components/Intranet/Comun/Estructura/Header/CHeader.vue";
import router from '@/router/index'
import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'

export default {
    props: {
        idContenedor: {
            type: Number,
            default: 0
        },
        tarjetas: {
            type: Array,
            default: () => []
        },
        opciones: {
            type: Object,
            default: () => ({ 
                conTitulo: { mostrar: false, texto: 'Titulo', estilosCss: '' },
                tarjetasPorFila: 4,
                centrarTarjetas: false,
                menuDeUsuario: []
            })
        },
    },
    directives: {
        tooltipF
    },
    components: {
        CHeader: CHeader
    },
    data() {
        return {
            ID_BASE: 'cardEnlaces',
            MAXIMO_ENLACES_MOSTRAR: 4,
            mostrarEnlacesOcultos: false
        }
    },
    methods: {
        esMenuDeUsuario: function({ nombreMenu }) { 
            let esMenuDeUsuario = false;
            if(this.campoRequeridoEsValido(nombreMenu) && this.campoRequeridoEsValido(this.opciones.menuDeUsuario)) {
                esMenuDeUsuario = this.opciones.menuDeUsuario.some(m => nombreMenu.replace(/\s/g,'').toUpperCase() == m.replace(/\s/g,'').toUpperCase());
            }
            return esMenuDeUsuario;
        },
        ocultarTooltip: function() {
            $(".tooltip").tooltip("hide");
            this.$nextTick(() => { 
               $(".tooltip").tooltip("hide");
            });
        },
        limitarLongitudDeEnlace: function(nombreEnlace) { 
            let nombreValido = nombreEnlace;
            if(this.campoRequeridoEsValido(nombreEnlace)) {
                nombreValido = nombreValido.toString();
                const MAXIMO_CARACTERES = 30;
                let numeroCaracteresEnlace = nombreEnlace.length;
                if(numeroCaracteresEnlace > MAXIMO_CARACTERES) {
                    nombreValido = nombreEnlace.toString().substring(0, MAXIMO_CARACTERES);
                    nombreValido += " ..."
                }
            }
            return nombreValido;
        },
        evtMostrarElacesOcultos: function({ crd, mostrar }) {
            console.log('tarjeta::',crd);
            this.$nextTick(() => { 
               if(!mostrar) {
                    let alturaBase = this.obtenerAlturaDeContenedor();
                    $('#contenedor-enlaces-' + crd.identificador).css("height", alturaBase);
               }
               else if(mostrar) {
                   /*  $('#contenedor-enlaces-' + crd.identificador).css('height','auto','important');  */
                    $('#contenedor-enlaces-' + crd.identificador).attr('style', 'height: auto !important');
               }
               crd.mostrarEnlacesOcultos = mostrar;
            });
        },
        irADocumentosDeArea: function(area) { debugger
            console.log('area:seleccionada::',area);
            const AREA = area.Titulo;
            if(this.campoRequeridoEsValido(AREA)) {
                /* const URL_AREA = AREA.replace(/\s/g, "").trim(); */
                router.push({ name: "DocumentosArea", params: { url: AREA, tipoDocumento: 'TodosLosDocumentos' } });
            }
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'array' || campo instanceof Array) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo.length > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        },
        obtenerAlturaDeContenedor: function() {
            let propAltura = '';
            let longitudEnlaces = this.tarjetas.map(t => { return t.enlaces.length });
            let mayorNumeroDeEnlaces = Math.max.apply(Math,longitudEnlaces);
            switch(true) {
                case (mayorNumeroDeEnlaces >= this.MAXIMO_ENLACES_MOSTRAR):
                    propAltura = '12vmin';
                break;
                case (mayorNumeroDeEnlaces == 3): 
                    propAltura = '8vmin';
                break;
                case (mayorNumeroDeEnlaces == 2):
                     propAltura = '6vmin';
                break;
                case (mayorNumeroDeEnlaces == 1): 
                     propAltura = '3vmin';
                break;
                default: 
                    propAltura = '2vmin';
                break;
            }
            return propAltura;
        },
        definirDimensionDeTarjetas: function() {
            this.$nextTick(() => { debugger
                const CONTENEDOR_ID = 'contenedor-enlaces';
                let altura = this.obtenerAlturaDeContenedor();
                $("[id^=" + CONTENEDOR_ID + "]").css("height", altura);
            });
        }
    },
    computed: {
        mostrarTarjetas() {
            return (this.campoRequeridoEsValido(this.tarjetas) && this.tarjetas.length > 0);
        }
    },
    watch: {
        tarjetas() { 
            this.definirDimensionDeTarjetas();
        }
    },
    created() {
        console.log('tarjetas::',this.tarjetas);
    },
}
</script>
<style scoped>
.deshabilitar-tarjeta {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.3;
}

@media screen and (max-width: 2400px) {
    .campos-descriptivos-area {
        height: 14vmin !important;
    }

    .campos-descriptivos-area i {
        font-size: 8vmin !important;
        margin-bottom: 5px;
    }

    .campos-descriptivos-area h3 {
        margin-bottom: 0px;
        font-size: 3vmin !important;
    }

    .campos-descriptivos-area h4 {
        font-size: 1.7vmin !important;
    }
}

@media screen and (max-width: 1400px) {
    .campos-descriptivos-area {
        height: 17vmin !important;
    }

    .campos-descriptivos-area i {
        font-size: 9vmin !important;
        margin-bottom: 5px;
    }

    .campos-descriptivos-area h3 {
        margin-bottom: 0px;
        font-size: 3vmin !important;
    }

    .campos-descriptivos-area h4 {
        font-size: 1.7vmin !important;
    }

    [id^="contenedor-enlaces"] {
        margin-top: 1vmin !important;
        height: 17.5vmin !important;
    }

    .enlace {
        color: black;
        font-size: 2.1vmin !important;
    }

    #icono-enlaces {
        font-size: 1.7vmin !important;
        margin-right: 0.3em;
    }

    #contenedor-acciones .btn-block {
        font-size: 2.5vmin !important;
    }

    #seccion-sin-enlaces h5 {
        font-size: 2vmin !important;
    }

    #contenedor-sin-enlaces i {
        font-size: 3vmin !important;
        vertical-align: middle !important;
    }
}

@media screen and (max-width: 1200px) {
    .campos-descriptivos-area {
        height: 14vmin !important;
    }

    .campos-descriptivos-area i {
        font-size: 7vmin !important;
        margin-bottom: 5px;
    }

    .campos-descriptivos-area h3 {
        margin-bottom: 0px;
        font-size: 2vmin !important;
    }

    .campos-descriptivos-area h4 {
        font-size: 1.3vmin !important;
    }

    [id^="contenedor-enlaces"] {
        margin-top: 1vmin !important;
        height: 16vmin !important;
    }

    .enlace {
        color: black;
        font-size: 1.5vmin !important;
    }

    #icono-enlaces {
        font-size: 1.5vmin !important;
        margin-right: 0.3em;
    }

    #contenedor-acciones {
        margin-top: 0.3vmin !important;
    }

    #contenedor-acciones .btn-block {
        font-size: 2vmin !important;
    }

    #seccion-sin-enlaces h5 {
        font-size: 1.5vmin !important;
    }

    #contenedor-sin-enlaces i {
        font-size: 2vmin !important;
        vertical-align: middle !important;
    }
}


@media screen and (max-width: 900px) {
    .campos-descriptivos-area {
        height: 16vmin !important;
    }

    .campos-descriptivos-area i {
        font-size: 6vmin !important;
        margin-bottom: 5px;
    }

    .campos-descriptivos-area {
        height: 16vmin !important;
    }

    [id^="contenedor-enlaces"] {
        margin-top: 0.5vmin !important;
        height: 18vmin !important;
    }

}

@media screen and (max-width: 574px) {
    .campos-descriptivos-area {
        height: 23vmin !important;
    }

    .campos-descriptivos-area i {
        font-size: 10vmin !important;
        margin-bottom: 5px;
    }

    .campos-descriptivos-area h3 {
        margin-bottom: 0px;
        font-size: 5.5vmin !important;
    }

    .campos-descriptivos-area h4 {
        font-size: 3.3vmin !important;
    }

    [id^="contenedor-enlaces"] {
        margin-top: 1vmin !important;
        height: 20vmin !important;
    }

    .enlace {
        color: black;
        font-size: 2.6vmin !important;
    }

    #icono-enlaces {
        font-size: 2.3vmin !important;
        margin-right: 0.3em;
    }

    #contenedor-acciones .btn-block {
        font-size: 2vmin !important;
    }

    [id^="contenedor-enlaces"] span {
        cursor: pointer;
        font-size: 2.8vmin !important;
        margin-top: 0.5vmin;
    }

    #contenedor-acciones .btn-block {
        font-size: 4vmin !important;
    }

    #seccion-sin-enlaces h5 {
        font-size: 5vmin !important;
    }

    #contenedor-sin-enlaces i {
        font-size: 6vmin !important;
        vertical-align: middle !important;
    }
}


#seccion-sin-enlaces {
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    height: 100%;
}

#seccion-sin-enlaces h5 {
    font-size: 3vmin;
    font-weight: bold;
}

#contenedor-sin-enlaces i {
    font-size: 4vmin;
    margin-bottom: 1vmin;
}

.enlaces-ocultos {
    display: none;
}

#contenedor-seccion-principal-intarnet {
    background-color: #FFFFFF;
    min-height: calc(100vh - 103px);
    color: #111;
}

[id^="contenedor-enlaces"] span {
    cursor: pointer;
    font-size: 1.8vmin;
    margin-top: 0.5vmin;
}

.contenedor-accion-enlaces-ocultos {
    display: flex !important;
    justify-content: center !important;
    text-align: center !important;
}

[id^="contenedor-enlaces"] span:hover, [id^="contenedor-enlaces"] span:focus {
    font-weight: bold;
}

.tarjeta-enlaces {
    background-color: #ffffff;
    border-radius: 4px;
    color: black;
    border: 1px solid #4F4949;
    padding: 20px 15px 20px 15px;
}

.titulo {
    font-size: 7vmin;
    font-weight: bold;
    text-align: center;
    margin-bottom: 0.5em;
}

.campos-descriptivos-area {
    text-align: center;
    justify-content: center;
    height: 16vmin;
}

.campos-descriptivos-area i {
    font-size: 10vmin;
    margin-bottom: 5px;
}

.campos-descriptivos-area h3 {
    font-weight: bold;
    margin-bottom: 0px;
    font-size: 3.3vmin;
}

.campos-descriptivos-area h4 {
    color: rgb(71, 71, 71);
    font-size: 2vmin;
}

[id^="contenedor-enlaces"] {
    margin-top: 3vmin;
    padding-right: 1em;
    padding-left: 1em;
    height: 12vmin;
}

.enlace {
    color: black;
    font-size: 1.6vmin;
}

.enlace:hover {
    font-weight: bold;
}

#icono-enlaces {
    font-size: 2.3vmin;
    margin-right: 0.3em;
    cursor: pointer;
    color: #be9a5e;
}
#contenedor-acciones {
    margin-top: 3.1vmin;
}

#contenedor-acciones .btn-block {
    background-color: black;
    font-size: 3vmin;
}

.contenedor-tarjetas-principal {
    padding: 8vmin 15vmin 13vmin 15vmin;
}

.titulo-area {
    cursor: pointer;
}


</style>


// WEBPACK FOOTER //
// src/components/Intranet/Formatos/CCardEnlaces.vue